module.exports = "/_next/static/images/LaunchIntegration-c4c4db927463779095b9eb988725f3ef.webp";